import { EditableStatus, ListStatus } from '@/store/types';
import { Profile } from './profile';

export const TERMS_AGREE_KEY = 'terms_agree';
export const DEVICE_SECURITY_AGREE_KEY = 'device_security_agree';

export enum UserRole {
  User = 'user',
  Sales = 'sales',
  Clinical = 'clinical',
  Admin = 'admin',
  SuperAdmin = 'superadmin',
  Distributor = 'distributor',
}

export enum ProfileStatus {
  Initial,
  Loading,
  Loaded,
  Saving,
  Saved,
  Error,
}

export enum ProfileActions {
  LOAD_PROFILE = 'LOAD_PROFILE',
  SAVE_PROFILE = 'SAVE_PROFILE',
  UPDATE_EDITABLE_PROFILE = 'UPDATE_EDITABLE_PROFILE',
  SET_PROFILE = 'SET_PROFILE',
  SAVE_TERMS_AGREE = 'SAVE_TERMS_AGREE',
  SHOW_TERMS_AGREE_MODAL = 'SHOW_TERMS_AGREE_MODAL',
  SAVE_DEVICE_SECURITY_AGREE = 'SAVE_DEVICE_SECURITY_AGREE',
  SET_LANGUAGE = 'SET_LANGUAGE',
  ENABLE_CHATBOT = 'ENABLE_CHATBOT',
  FETCH_ADS = 'FETCH_ADS',
  DISMISS_AD = 'DISMISS_AD',
  CHECK_NEW_PRODUCTS = 'CHECK_NEW_PRODUCTS',
  OPEN_CLINICAL_EVENTS_MODAL = 'OPEN_CLINICAL_EVENTS_MODAL',
  CLOSE_CLINICAL_EVENTS_MODAL = 'CLOSE_CLINICAL_EVENTS_MODAL'
}

export enum ProfileMutations {
  SET_CURRENT_PROFILE = 'SET_CURRENT_PROFILE',
  SET_EDITABLE_PROFILE = 'SET_EDITABLE_PROFILE',
  UPDATE_EDITABLE_PROFILE = 'UPDATE_EDITABLE_PROFILE',
  SET_CURRENT_PROFILE_STATUS = 'SET_CURRENT_PROFILE_STATUS',
  SET_EDITABLE_PROFILE_STATUS = 'SET_EDITABLE_PROFILE_STATUS',
  SET_TERMS_AGREE = 'SET_TERMS_AGREE',
  SHOW_TERMS_AGREE_MODAL = 'SHOW_TERMS_AGREE_MODAL',
  SET_DEVICE_SECURITY_AGREE = 'SET_DEVICE_SECURITY_AGREE',
  SET_SHOULD_LOAD_CHATBOT = 'SET_SHOULD_LOAD_CHATBOT',
  SET_CURRENT_AD = 'SET_CURRENT_AD',
  SET_AD_DISMISSED = 'SET_AD_DISMISSED',
  SET_NEW_PRODUCTS_DISMISSED = 'SET_NEW_PRODUCTS_DISMISSED',
  SET_CLINICAL_EVENTS_MODAL_DISMISSED = 'SET_CLINICAL_EVENTS_MODAL_DISMISSED',
  SET_SHOW_CLINICAL_EVENTS_MODAL = 'SET_SHOW_CLINICAL_EVENTS_MODAL'
}

export interface Ad {
  image: string;
  link: string;
  specificProducts: string[];
  expiresAt: string;
}

export interface ProfileState {
  status: ListStatus;
  currentProfile: Profile;
  editableProfile?: Profile;
  initialEditableProfile?: Profile;
  editableStatus: EditableStatus;
  local_terms_agree: 0 | 1;
  show_terms_agree_modal: 0 | 1;
  local_device_security_agree: 0 | 1;
  showChatBot: boolean;
  currentAd: Ad | null;
  newProductsDismissed: boolean;
  clinicalEventsModalDismissed: boolean;
  showClinicalEventsModal: boolean;
}
